import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { VehicleGroupsPage } from "@/features/vehicle-groups/pages/vehicle-groups-page";
import { vehicleGroupFilterSchema } from "@/features/vehicle-groups/schemas/vehicle-group-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/vehicle-groups/")({
	head: () => pageTitle("Vehicle groups"),
	component: VehicleGroupsPage,
	validateSearch: zodValidator(vehicleGroupFilterSchema),
});
